module.exports = __webpack_public_path__ + "static/ChaCha_preview-e7158843cfb9cfac374e0f73060a382c.jpg";